import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";
import { Grid, Box, Typography } from "@mui/material";
import CMSDrivenPageTemplateStyles from "./CMSDrivenPageTemplate.styles";
import ImageAnchoredParagraph from "../CMSSharedComponents/ImageAnchoredParagraph";
import CardGrid from "../CMSSharedComponents/CardGrid";
import HeroCardGrid from "../CMSSharedComponents/HeroCardGrid";
import HeroHeader from "../CMSSharedComponents/HeroHeader";
import ImageWithFooterCard from "../CMSSharedComponents/ImageWithFooterCard";
import OptionWithIconCard from "../CMSSharedComponents/OptionWithIconCard";
import ResourceGrid from "../CMSSharedComponents/ResourceGrid";
import ResourceGridMatrix from "../CMSSharedComponents/ResourceGridMatrix";
import Article from "../CMSSharedComponents/Article";
import LinkBoxGrid from "../CMSSharedComponents/LinkBoxGrid";
import ContentResolver from "../CMSSharedComponents/ContentResolver";
import LinkChildren from "../CMSSharedComponents/LinkChildren";
import ContentHeading from "../CMSSharedComponents/ContentHeading";
import CmsBreadcrumb from "../CMSSharedComponents/CmsBreadcrumb";
import Questions from "../CMSSharedComponents/Questions";
import RelatedArticlesGrid from "../CMSSharedComponents/RelatedArticlesGrid";
import LinkArticles from "../CMSSharedComponents/LinkArticles";
import ArticleExternal from "../CMSSharedComponents/ArticleExternal";
import LinkTopicsAndArticles from "../CMSSharedComponents/LinkTopicsAndArticles";
import PersonalizedResources from "../CMSSharedComponents/PersonalizedResources";

const Components = {
  ImageAnchoredParagraph: ImageAnchoredParagraph,
  CardGrid: CardGrid,
  HeroCardGrid: HeroCardGrid,
  HeroHeader: HeroHeader,
  ImageWithFooterCard: ImageWithFooterCard,
  OptionWithIconCard: OptionWithIconCard,
  ResourceGrid: ResourceGrid,
  PersonalizedResources: PersonalizedResources,
  ResourceGridMatrix: ResourceGridMatrix,
  Article: Article,
  LinkBoxGrid: LinkBoxGrid,
  LinkChildren: LinkChildren,
  ContentHeading: ContentHeading,
  Questions: Questions,
  RelatedArticlesGrid: RelatedArticlesGrid,
  LinkArticles: LinkArticles,
  ArticleExternal: ArticleExternal,
  LinkTopicsAndArticles: LinkTopicsAndArticles
};

const CMSDrivenPageTemplate = (props) => {
  const { pages, page, gutters } = props;

  const classes = CMSDrivenPageTemplateStyles();

  return (
    <GradientFramedLayout showHeader={true}>
      <Box
        sx={{
          paddingBottom: "32px",
          paddingTop: "40px",
          paddingX: { xs: 2, md: 3 },
          width: "100%"
        }}
      >
        <Grid container justifyContent="center">
          <Box className={classes.contentWrapper}>
            <CmsBreadcrumb page={page} pages={pages} />
            <div>
              {page?.componentTypes?.map((component) => {
                const Component = Components[component.componentType];
                return Component ? (
                  <Component
                    material={component}
                    pages={pages}
                    gutters={gutters}
                    page={page}
                  />
                ) : null;
              })}
              {!page?.componentTypes || page?.componentTypes.length === 0 ? (
                <Typography
                  variant="body_strong_xl"
                  className={classes.headline}
                  style={{
                    textAlign: "center",
                    marginTop: "6rem"
                  }}
                >
                  <ContentResolver content="Oops..." />
                  <a
                    style={{
                      display: "block",
                      textAlign: "center",
                      fontSize: "1rem",
                      marginTop: "2rem"
                    }}
                    href="../"
                  >
                    « Back
                  </a>
                </Typography>
              ) : null}
            </div>
          </Box>
        </Grid>
      </Box>
    </GradientFramedLayout>
  );
};

export default CMSDrivenPageTemplate;
